import { Route, Routes, useLocation } from "react-router-dom";
import Navbar from "../../../../default-components/Navbar";
import PGBusinessThreeHome from "../businessThreePages/PGBusinessThreeHome";
import ColorsComponent from "../../../../default-components/ColorsComponent";
import FooterUpper from "../../../../default-components/FooterUpper";
import Footer from "../../../../default-components/Footer";
import "../businessThreeCss/BusinessThreeStyle.scss";
import GlobalRoute from "../../../../global route/GlobalRoute";
import PGBusinessThreeAboutUs from "../businessThreePages/PGBusinessThreeAboutUs";
import BusinessThreeNavbar from "../businessThreeComponents/BusinessThreeNavbar";
import { useDocument } from "../../../../firebase-files/hooks/useDocument";
import { useAuthContext } from "../../../../firebase-files/hooks/useAuthContext";
import PGDashboard from "../../../../allRoles/dashboards/PGDashboard";

const BusinessThreeRoute = () => {
  const { document: navTypeDoc } = useDocument("settings", "navbarType");
  const location = useLocation();
  // Check if current path is NOT /chat-with-botify
  const showNavbar = location.pathname !== "/chat-with-botify";
  return (
    <div>
      <>
        {showNavbar &&
          (navTypeDoc && navTypeDoc.activeNav === "FixNav" ? (
            <Navbar />
          ) : (
            <BusinessThreeNavbar />
          ))}

        <Routes>
          <Route path="/" element={<PGBusinessThreeHome />}></Route>
          <Route path="/aboutus" element={<PGBusinessThreeAboutUs />} />
          <Route path="/dashboard" element={<PGDashboard />}></Route>
        </Routes>
        <ColorsComponent />
        <GlobalRoute />
        {showNavbar && (
          <>
            <FooterUpper />
            <Footer />
          </>
        )}
      </>
    </div>
  );
};

export default BusinessThreeRoute;
